/**
 * 장착 휠 순서
 */
export const wheelMarkerForm = [
  { key: 1, title: "결제완료", date: "paymentCompletedAt" },
  { key: 3, title: "주문확정", date: "orderConfirmedAt" },
  { key: 5, title: "작업완료", date: "serviceCompletedAt" },
  { key: 7, title: "구매확정", date: "purchaseConfirmedAt" },
];
